import React from "react";
import SocialMedia from "./SocialMedia";
import {Col, Row,Typography ,List} from 'antd';
const {Link} = Typography;

const f_list_one = [
  {
    title: 'HOME',
    url : '#',
  },
  {
    title: 'TESTNET',
    url : '#',
  },
  {
    title: 'TEST-DRIVE',
    url : '#',
  },
  {
    title: 'SIGN IN',
    url : '#',
  },
  {
    title: 'SIGN IN USING SYNC 2',
    url : '#',
  },
];
const f_list_sec = [
  {
    title: 'ABOUT US',
    url : '#',
  },
  {
    title: 'COMPANIES',
    url : '#',
  },
  {
    title: 'FAQ',
    url : '#',
  },
  {
    title: 'COPYRIGHT POLICY',
    url : '#',
  },
];
const f_list_th = [
  {
    title: 'VECHAIN.ENERGY',
    url : '#',
  },
  {
    title: 'SOLUTIONS',
    url : '#',
  },
  {
    title: 'READING DATA',
    url : '#',
  },
  {
    title: 'TRANSACTIONS',
    url : '#',
  },
  {
    title: 'PUSH WITH WEBHOOKS',
    url : '#',
  },
];
const Footer = () =>{ 
 return(
  <footer className="footer">
    <div className="container">
      <Row>
        <Col sm={24} md={12} lg={6}>
          <img src="../../images/footer-logo.png" className="img-fluid" alt=""/>
        </Col>
         <Col sm={24} md={12} lg={6}>
          <div className="footer-inner">
            <List
              itemLayout="horizontal"
              dataSource={f_list_one}
              renderItem={(item) => (
              <List.Item>
                <Link className="footer-link" href={item.url}>{item.title}</Link>
              </List.Item>
              )}
            />
           </div>
         </Col>
         <Col sm={24} md={12} lg={6}>
          <div className="footer-inner">
            <List
              itemLayout="horizontal"
              dataSource={f_list_sec}
              renderItem={(item) => (
              <List.Item>
                <Link className="footer-link" href={item.url}>{item.title}</Link>
              </List.Item>
              )}
            />
           </div>
         </Col>
         <Col sm={24} md={12} lg={6}>
          <div className="footer-inner">
            <List
              itemLayout="horizontal"
              dataSource={f_list_th}
              renderItem={(item) => (
              <List.Item>
                <Link className="footer-link" href={item.url}>{item.title}</Link>
              </List.Item>
              )}
            />
           </div>
         </Col>
      </Row>
      <SocialMedia/>
    </div>
  </footer>
 )
}
export default Footer;